// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"1daaa267","239":"fcaddd2b","553":"df1d4408"}[chunkId] + ".chunk.js";
};